import { Component, OnInit } from '@angular/core';
import { RedirectService } from 'src/app/shared/services/redirect.service';
import {ErrorService} from '../../shared/services/error.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
  constructor(public errorService: ErrorService,
    private redirectService: RedirectService,
    ) {}

  ngOnInit(): void {}

  onLogout(){
    this.redirectService.redirectToSAMLLogout();
  }
}
